/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkingModeApplyResponseWorkingMode =
  (typeof WorkingModeApplyResponseWorkingMode)[keyof typeof WorkingModeApplyResponseWorkingMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingModeApplyResponseWorkingMode = {
  custom: 'custom',
  classic_essays: 'classic_essays',
  ai_tutor_oral: 'ai_tutor_oral',
} as const;
